var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-popover",
        {
          ref: "popover-org-tree",
          attrs: { placement: "top-start", trigger: "click" }
        },
        [
          _c("div", { staticClass: "popover-tree" }, [
            _c("div", { staticClass: "hint block row" }, [
              _c("i", {
                staticClass: "icon iconfont icon-tongzhi1 mr10 font-gold"
              }),
              _vm._v(" "),
              _c("span", [_vm._v("温馨提示：鼠标双击选中")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tab-container small base" }, [
              _c("div", { staticClass: "tabs-nav" }, [
                _c(
                  "ul",
                  { staticClass: "head" },
                  _vm._l(_vm.tableState, function(status) {
                    return _c(
                      "li",
                      {
                        staticClass: "head-item",
                        class: { current: status.value == _vm.checkStateValue },
                        on: {
                          click: function($event) {
                            _vm.handleTabClick(status.value)
                          }
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(status.text))])]
                    )
                  })
                )
              ])
            ]),
            _vm._v(" "),
            _vm.checkStateValue == 0
              ? _c(
                  "div",
                  [
                    _c("swb-org-tree", {
                      attrs: {
                        bizDepart: _vm.bizDepart || _vm.departFlag,
                        includeUnOpenedFlag: _vm.includeUnOpenedFlag,
                        isSelectThisLevel: _vm.isSelectThisLevel,
                        dblclickFlag: true,
                        isCom: _vm.isCom,
                        accordion: _vm.accordion,
                        enableSearch: true,
                        isShowIcon: false,
                        closedComSelect: _vm.closedComSelect,
                        comFlag: _vm.comFlag,
                        deaprtFlag: _vm.deaprtFlag
                      },
                      on: {
                        "notity-change": function($event) {
                          _vm.notityChange($event)
                        },
                        "notity-init-change": function($event) {
                          _vm.notityInitChange($event)
                        }
                      }
                    })
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c("swb-real-com-tree", {
                      attrs: {
                        enableSearch: true,
                        accordion: _vm.accordion,
                        dblclickFlag: true,
                        costFlag: _vm.costFlag,
                        prftFlag: _vm.prftFlag,
                        selectRealComId: _vm.selectRealComId
                      },
                      on: {
                        "notity-change": function($event) {
                          _vm.notityChange($event)
                        },
                        "notity-init-change": function($event) {
                          _vm.notityInitChange($event)
                        }
                      }
                    })
                  ],
                  1
                )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showFlag,
                  expression: "showFlag"
                }
              ],
              staticClass: "org-tree-btn",
              attrs: { slot: "reference" },
              slot: "reference"
            },
            [
              _c("span", [_vm._v("选择机构")]),
              _vm._v(" "),
              _c("i", { staticClass: "icon iconfont icon-down-sanjiao" })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "org-tree-factor" }, [
        _c("div", { staticClass: "factor-item" }, [
          _vm.showFlag ? _c("span", [_vm._v("【选中机构】")]) : _vm._e(),
          _vm._v(" "),
          !_vm.showFlag ? _c("span", [_vm._v("【当前机构】")]) : _vm._e(),
          _vm._v(" "),
          _vm.itemInfo.id != null
            ? _c("span", [_vm._v(_vm._s(_vm.displayName))])
            : _c("span", [_vm._v("无")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.itemInfo.level <= 4 && _vm.checkStateValue == 0,
                expression: "itemInfo.level <= 4 && checkStateValue == 0"
              }
            ],
            staticClass: "factor-item"
          },
          [
            _vm.showIncludeSubComs == true
              ? _c(
                  "el-checkbox",
                  {
                    on: { change: _vm.handleCheckedChange },
                    model: {
                      value: _vm.includeSubComs,
                      callback: function($$v) {
                        _vm.includeSubComs = $$v
                      },
                      expression: "includeSubComs"
                    }
                  },
                  [_vm._v("全部下级机构")]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d91523c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d91523c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/orgStruct/PopoverOrgTree.vue
// module id = 1954
// module chunks = 1